import { EThemeName } from '@wind-log_library/fe-component-library';
import { environment } from 'src/environments/environment';

export const NAVIGATION_ICONS = [
  {
    key: 'nav-monitor',
    [EThemeName.DARK]: `${environment.shared_server}/general/module-icons/icon-monitor-dark.svg`,
    [EThemeName.LIGHT]: `${environment.shared_server}/general/module-icons/icon-monitor-light.svg`,
  },
  {
    key: 'nav-monitor-selected',
    [EThemeName.DARK]: `${environment.shared_server}/general/module-icons/icon-monitor-dark.svg`,
    [EThemeName.LIGHT]: `${environment.shared_server}/general/module-icons/icon-monitor-dark.svg`,
  },
    {
    key: 'nav-report',
    [EThemeName.DARK]: `${environment.shared_server}/general/module-icons/icon-report-dark.svg`,
    [EThemeName.LIGHT]: `${environment.shared_server}/general/module-icons/icon-report-light.svg`
  },
  {
    key: 'nav-report-selected',
    [EThemeName.DARK]: `${environment.shared_server}/general/module-icons/icon-report-dark.svg`,
    [EThemeName.LIGHT]: `${environment.shared_server}/general/module-icons/icon-report-dark.svg`
  },
];
